'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // eslint-disable-line


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bemReactCore = require('bem-react-core');

var _eGemiusMTypeJs = (require('./__gemius/b-statcounter__gemius.react.js'), (require('./__gemius/_type/b-statcounter__gemius_type_js.react.js').default || require('./__gemius/_type/b-statcounter__gemius_type_js.react.js')).applyDecls());

var _eGemiusMTypeJs2 = _interopRequireDefault(_eGemiusMTypeJs);

var _eMetrikaMTypeJs = (require('./__metrika/b-statcounter__metrika.react.js'), (require('./__metrika/_type/b-statcounter__metrika_type_js.react.js').default || require('./__metrika/_type/b-statcounter__metrika_type_js.react.js')).applyDecls());

var _eMetrikaMTypeJs2 = _interopRequireDefault(_eMetrikaMTypeJs);

var _eTnsMTypeJs = (require('./__tns/b-statcounter__tns.react.js'), (require('./__tns/_type/b-statcounter__tns_type_js.react.js').default || require('./__tns/_type/b-statcounter__tns_type_js.react.js')).applyDecls());

var _eTnsMTypeJs2 = _interopRequireDefault(_eTnsMTypeJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gemiusCountries = ['ua', 'by'];
var gemiusCountriesCodes = {
    187: 'ua',
    149: 'by'
};

exports.default = (0, _bemReactCore.decl)({
    block: 'b-statcounter',
    tag: 'i',
    content: function content() {
        var result = [],
            _props = this.props,
            gemius = _props.gemius,
            metrika = _props.metrika,
            tns = _props.tns;


        if (gemius) {
            var region = void 0;
            var country = gemius.country;


            if (gemiusCountries.indexOf(country) !== -1) {
                region = country;
            } else {
                // Если передали числовой индекс страны – то конвертируем в строчный
                region = gemiusCountriesCodes[country];
            }

            if (region) {
                result.push(_react2.default.createElement(_eGemiusMTypeJs2.default, _extends({
                    region: region
                }, gemius, {
                    key: 'gemius-' + gemius.country })));
            } else {
                throw 'Неверно указаны параметры счетчика gemius. Передайте параметр ' + '"country" с кодом страны, или строкой("ua" или "by")';
            }
        }

        if (metrika) {
            result.push(_react2.default.createElement(_eMetrikaMTypeJs2.default, _extends({}, metrika, {
                // Для type=js параметры передаются в counterParams(там тоже может прийти type)
                key: 'metrika-' + (metrika.counter || metrika.counterParams.id) })));
        }

        if (tns) {
            result.push(_react2.default.createElement(_eTnsMTypeJs2.default, _extends({}, tns, {
                key: 'tns-' + tns.id })));
        }

        return result;
    }
});